import Toast from "./Toast";
import { useToast } from "@/hooks/useToast";

export default function ShareButton({ className = "" }: { className?: string }) {
  const { message, show } = useToast();

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("textarea");
        input.value = url;
        input.style.position = "fixed";
        input.style.opacity = "0";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      show("链接已复制到剪贴板");
    } catch {
      show("复制失败，请手动复制地址栏链接");
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleShare}
        className={`inline-flex items-center justify-center gap-2 px-5 h-11 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap ${className}`}
      >
        <i className="ri-share-forward-line text-lg" />
        分享链接
      </button>
      <Toast message={message} />
    </>
  );
}